import React from 'react';
import { css, cx } from 'emotion';
import toTitleCase from 'to-title-case';

import { socialLinks } from '../utils/config';
import { options } from '../utils/typography';
import { baselineGrid, colors, animation } from '../utils/presets';
import { toRem, fp, mqObj as mq } from '../utils/functions';

import InnerWrapper from '../components/inner-wrapper';
import { ReactComponent as SocialIconTwitter } from '../assets/svgr/social-icon-twitter.svg';
import { ReactComponent as SocialIconFacebook } from '../assets/svgr/social-icon-facebook.svg';
import { ReactComponent as SocialIconInstagram } from '../assets/svgr/social-icon-instagram.svg';

const { curve, speed } = animation;

const iconsMap = new Map([
  ['twitter', SocialIconTwitter],
  ['facebook', SocialIconFacebook],
  ['instagram', SocialIconInstagram],
]);

const spacing = fp({
  margin: [
    `${toRem(baselineGrid * 4)} auto`,
    `${toRem(baselineGrid * 6)} auto`,
    `${toRem(baselineGrid * 8)} auto`,
  ],
});

const socialIcons = css`
  ${spacing};
`;

const socialIconsWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: ${toRem(baselineGrid * 144)};

  ${mq.lap} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const socialIconsCell = css`
  align-self: center;
  text-align: center;
  padding: ${toRem(baselineGrid * 2)};
  font-family: ${options.headerFontFamily.join(',')};
  font-size: ${toRem(baselineGrid * 3)};
  line-height: ${toRem(baselineGrid * 4)};
  color: ${colors.gray.gunpowder};

  ${mq.lap} {
    width: calc(50% - ${toRem(baselineGrid)});
  }

  ${mq.lapLarge} {
    width: auto;
  }
`;

const socialIconsLink = css`
  text-decoration: none;
  color: ${colors.gray.gunpowder};
  transition: color ${speed.fast} ${curve.default};

  &:hover,
  &:active,
  &:focus {
    color: ${colors.blue};
  }
`;

const socialIconsIcon = css`
  display: inline-block;
  vertical-align: middle;
  margin-right: ${toRem(baselineGrid)};
  transform: translateY(${toRem(baselineGrid * -0.5)});
  width: ${toRem(baselineGrid * 6)};

  [class$='layer'] {
    mix-blend-mode: hard-light;
  }

  .bottom-layer {
    fill: currentColor;
  }
`;

const SocialIcons = () => (
  <nav css={socialIcons}>
    <InnerWrapper className={socialIconsWrapper} narrow>
      <span className={socialIconsCell}>
        <span>{toTitleCase('Follow us on:')}</span>
      </span>
      {socialLinks.sort((a, b) => a.order - b.order).map((item, index) => {
        const Icon = iconsMap.get(String(item.label).toLowerCase());

        return (
          <a
            key={index}
            href={item.path}
            className={cx(socialIconsCell, socialIconsLink, String(item.label).toLowerCase())}
            target="_blank"
          >
            {Icon && <Icon className={cx(socialIconsIcon, 'icon')} />}
            <span>{item.label}</span>
          </a>
        );
      })}
    </InnerWrapper>
  </nav>
);

export default SocialIcons;



// WEBPACK FOOTER //
// ./src/components/social-icons.js